import {Routes, Route, useNavigate} from 'react-router-dom';
import Dashboard from "./Pages/Dashboard/Dashboard";

import Quotes from "./Pages/Quotes/Quotes";
import Add from "./Pages/Quotes/Add";

import CreateClaim from "./Pages/Account/CreateClaim";
import Overview from "./Pages/Account/Overview";

import Wifi from "./Pages/Wifi/Wifi";

import "./General CSS/style.css";
import React, { useEffect } from "react";
import Login from "./Auth/Login";
import { PrivateRoute } from "./Auth/PrivateRoute";
import {setRedirectHandler} from "./API/API";
import ViewClaims from "./Pages/Account/ViewClaims";
import Note from "./Pages/Account/Note";
import Account from "./Pages/PayeesManager/Account";
import AccountEditor from "./Pages/PayeesManager/AccountEditor";
import NewAccount from "./Pages/PayeesManager/NewAccount";
import Rota from "./Pages/Rota/Rota";

const App: React.FC = () => {
    const navigate = useNavigate();

    useEffect(() => {
        setRedirectHandler(() => () => navigate("/login"));
    }, [navigate]);

    return (
        <Routes>
            <Route element={<PrivateRoute />}>
                <Route path="/" element={<Dashboard />} />

                <Route path="/quotes" element={<Quotes />} />
                <Route path="/quotes/add" element={<Add />} />

                <Route path="/account/overview" element={<Overview />} />
                <Route path="/account/create-claim" element={<CreateClaim />} />
                <Route path="/account/view-claims" element={<ViewClaims />} />
                <Route path="/account/my-account" element={<Account />} />
                <Route path="/account/my-account/edit" element={<AccountEditor />} />
                <Route path="/account/my-account/add" element={<NewAccount />} />
                <Route path="/account/note/:categoryUid/:id" element={<Note />} />
                <Route path="/rota" element={<Rota />} />

                <Route path="/info/wifi" element={<Wifi />} />
            </Route>
            <Route path="/login" element={<Login />} />
        </Routes>
    );
}

export default App;